/**
 * Pure query-string builder for `GET /api/admin/payouts/pending-balances`.
 *
 * Default / empty values are omitted so the URL stays minimal and lines up
 * with the React Query cache key. Returns an empty string (no leading `?`)
 * when nothing is set, so callers can do `${path}${buildPendingBalancesQuery(f)}`.
 *
 * Side-effect free — unit-tested in `pending-balances-filters.test.ts`.
 */
import type { ConnectFilter } from "./constants";

export interface PendingBalancesFilters {
  readonly connect: ConnectFilter;
  /** Months; `null` = no age filter. */
  readonly olderThanMonths: number | null;
}

export function buildPendingBalancesQuery(filters: PendingBalancesFilters): string {
  const params = new URLSearchParams();

  if (filters.connect === "connected") {
    params.set("venueOwnerHasConnect", "true");
  } else if (filters.connect === "not-connected") {
    params.set("venueOwnerHasConnect", "false");
  }

  if (
    filters.olderThanMonths !== null &&
    Number.isFinite(filters.olderThanMonths) &&
    filters.olderThanMonths > 0
  ) {
    params.set("olderThanMonths", String(filters.olderThanMonths));
  }

  const qs = params.toString();
  return qs.length > 0 ? `?${qs}` : "";
}
